// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "highlightjs" + "." + "7b7705451651153be1c8" + ".css";
};